// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import VueBarcodeScanner from 'vue-barcode-scanner'
import VueBarcode from '@chenfengyuan/vue-barcode';
import Vuesax from 'vuesax'
import VeeValidate from 'vee-validate';
// import BootstrapVue2 from 'bootstrapVue2';
import BootstrapVueOld from 'bootstrapVueOld';
import DatePicker from 'vue2-datepicker';
import VueApexCharts from 'vue-apexcharts';
import App from './App'

import router from './router'

import {abilitiesPlugin} from '@casl/vue'
import {ability} from "./store";

/* FOR MANAGING USER PERMISSIONS */
Vue.use(abilitiesPlugin, ability);
/* FOR MANAGING USER PERMISSIONS */

import axios from 'axios'
import ApiService from './services/api.service'
import {TokenService} from './services/storage.service'
import store from './store'
import i18n from './lang/lang'
import VueCurrencyFilter from 'vue-currency-filter'

//import { TreeViewPlugin } from "@syncfusion/ej2-vue-navigations";

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import JsonExcel from "vue-json-excel";
import numkeyboard from 'vue-numkeyboard';
Vue.use(numkeyboard);

import 'vue-numkeyboard/style.css';
import 'element-ui/lib/theme-chalk/index.css';

/* Highcharts */
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import variable from 'highcharts/modules/variable-pie'
import donut from 'highcharts/highcharts-3d'
import pareto from 'highcharts/modules/pareto'
import color from 'highcharts/modules/coloraxis'
import cylinder from 'highcharts/modules/cylinder'
import exporting from 'highcharts/modules/exporting'

import column3D from 'highcharts/modules/funnel3d'
Vue.use(HighchartsVue)
variable(Highcharts)
donut(Highcharts)
pareto(Highcharts)
color(Highcharts)
cylinder(Highcharts)
exporting(Highcharts)



Vue.component("downloadExcel", JsonExcel);
Vue.component("treeselect", Treeselect);
// import { BOverlay } from 'bootstrap-vue'
// Vue.component('b-overlay', BOverlay)
// import { OverlayPlugin } from 'bootstrap-vue'
// Vue.use(OverlayPlugin)
// todo
// cssVars()
Vue.prototype.$roundToTwo = function (num) {
	let myNumber = parseFloat(Number(num).toFixed(2));
	return Number(Math.round(num + 'e2') + 'e-2');
};
//Vue.use(TreeViewPlugin);
Vue.use(BootstrapVueOld);
// Vue.use(BootstrapVue2);
Vue.use(Vuesax);
Vue.use(DatePicker);
Vue.use(VueBarcodeScanner);
Vue.use(VueApexCharts)
Vue.use(VeeValidate,
	{
		fieldsBagName: 'validationFields'
	});

/** GLOBAL CURRENCY FILTER BEGIN **/
Vue.use(VueCurrencyFilter, {
	symbol : '',
	thousandsSeparator: ' ',
	fractionCount: 0,
	fractionSeparator: '.',
	symbolPosition: 'back',
	symbolSpacing: true
});
/** GLOBAL CURRENCY FILTER END **/

// GLOBAL EVENT BUS
Vue.prototype.$eventHub = new Vue();

/** GLOBAL CLICK-OUTSIDE DIRECTIVE BEGIN **/
Vue.directive('click-outside', {
	bind: function (el, binding, vnode) {
		Window.event = function (event) {
			if (!(el == event.target || el.contains(event.target))) {
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener('click', Window.event)
	},
	unbind: function (el) {
		document.body.removeEventListener('click', Window.event)
	},
});
/** GLOBAL CLICK-OUTSIDE DIRECTIVE END **/

Vue.prototype.axios = axios;
/* eslint-disable no-new */

Vue.component(VueBarcode.name, VueBarcode);
Vue.component('apexchart', VueApexCharts)



// Event Bus
window.Fire = new Vue();

// SET THE BASE_URL OF THE API
ApiService.init(process.env.VUE_APP_ROOT_API);
ApiService.mount401Interceptor();

// IF TOKEN EXISTS SET HEADER
if (TokenService.getToken()) {
	ApiService.setHeader();
	ApiService.mount401Interceptor();
}


import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import pieChart from "@/views/dashboard-analytics/pieChart.vue";


export const app = new Vue({
	el: '#app',
	store,
	router,
	i18n,
	template: '<App/>',
	components: {
		App
	},
});
